import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

const AddHackathon = () => {
  const [form, setForm] = useState({
    title: "", organizer: "", mode: "Online", prize: "", deadline: "", link: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "hackathons"), {
        ...form,
        prize: form.prize ? Number(form.prize) : null,
      });
      setSuccess(true);
      setForm({ title: "", organizer: "", mode: "Online", prize: "", deadline: "", link: "" });
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error("Error adding hackathon:", err);
    }
    setLoading(false);
  };

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Add New Hackathon</h2>

      {success && (
        <div className="mb-4 flex items-center gap-2 p-3 bg-green-50 border border-green-100 rounded-lg">
          <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-sm text-green-700">Hackathon added successfully!</span>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
            <input name="title" value={form.title} onChange={handleChange} required className="input-field" placeholder="e.g. HackFest 2025" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Organizer</label>
            <input name="organizer" value={form.organizer} onChange={handleChange} required className="input-field" placeholder="e.g. MLH" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mode</label>
            <select name="mode" value={form.mode} onChange={handleChange} className="filter-select">
              <option value="Online">Online</option>
              <option value="Offline">Offline</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Prize Amount</label>
            <input name="prize" value={form.prize} onChange={handleChange} type="number" min="0" className="input-field" placeholder="e.g. 50000" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Deadline</label>
            <input name="deadline" value={form.deadline} onChange={handleChange} type="date" className="input-field" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Link</label>
            <input name="link" value={form.link} onChange={handleChange} className="input-field" placeholder="https://..." />
          </div>
        </div>

        <button type="submit" className="button btn-primary" disabled={loading}>
          {loading ? "Adding..." : "Add Hackathon"}
        </button>
      </form>
    </div>
  );
};

export default AddHackathon;
